import CryptoJS from "crypto-js";

import router from "@/router";

import api from "@/api/user";
import keys from "@/config/keys";

export const checkAuth = ({ commit, dispatch }) => {
  let token = "";
  let expiration = "";

  token = localStorage.getItem("token");
  expiration = localStorage.getItem("expiration");

  if (!token || !expiration) {
    dispatch("clearData", null, {
      root: true
    });
  }

  if (Date.now() > parseInt(expiration)) {
    dispatch("clearData", null, {
      root: true
    });
    dispatch(
      "showNotification",
      {
        message: "Unauthorized",
        type: "error"
      },
      {
        root: true
      }
    );
  } else {
    try {
      token = CryptoJS.AES.decrypt(
        token.toString(),
        keys.CLIENT_SECRET
      ).toString(CryptoJS.enc.Utf8);
      commit("SET_TOKEN", token);
      dispatch("getUserInfo");
    } catch (error) {
      dispatch("clearData", null, {
        root: true
      });
    }
  }
};

export const enterUser = ({ commit, dispatch }, { res, isFirstEnter }) => {
  commit("LOGIN_USER", res);
  commit("SET_TOKEN", res.access_token);
  dispatch("getUserInfo");

  router.push({
    name: isFirstEnter ? "onboarding" : "app"
  });
};

export const loginUser = ({ dispatch }, { email, password }) => {
  // dispatch("showSpinner", "Login user", {
  //   root: true
  // });

  const data = {
    client_id: 2,
    client_secret: keys.CLIENT_SECRET,
    grant_type: "password",
    username: email,
    password: password,
    scope: "*"
  };

  api
    .loginUser(data)
    .then(res => {
      // dispatch("hideSpinner", null, {
      //   root: true
      // });

      // console.log(dispatch);

      dispatch("enterUser", {
        res: res.data,
        isFirstEnter: false
      });

      // commit("LOGIN_USER", res.data);
      // commit("SET_TOKEN", res.data.access_token);
      // dispatch("getUserInfo");

      // router.push({
      //   name: "app"
      // });
    })
    .catch(error => {
      dispatch("hideSpinner", null, {
        root: true
      });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const getUserInfo = ({ commit, rootState, dispatch }) => {
  api
    .getUser()
    .then(res => {
      commit("SET_USER", res.data);
    })
    .catch(error => {
      let message;
      if (rootState.connected) {
        dispatch("clearData", null, {
          root: true
        });
        message = error.response.data.message;

        dispatch(
          "showNotification",
          {
            message,
            type: "error"
          },
          {
            root: true
          }
        );
      }
    });
};

export const registerUser = ({ commit, dispatch }, playload) => {
  dispatch(
    "showSpinner",
    {
      title: "Register new user"
    },
    {
      root: true
    }
  );

  api
    .registerUser(playload)
    .then(res => {
      dispatch("hideSpinner", null, {
        root: true
      });
      commit("SET_TOKEN", res.data.access_token);
      commit("LOGIN_USER", res.data);
      router.push({
        name: "onboarding"
      });
    })
    .catch(error => {
      dispatch("hideSpinner", null, {
        root: true
      });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const updateUser = ({ commit, dispatch }, { toChange, updated }) => {
  dispatch(
    "showSpinner",
    {
      title: "Update user"
    },
    {
      root: true
    }
  );

  commit("SET_USER", updated);

  const formData = new FormData();
  formData.append("name", toChange.name);
  formData.append("surname", toChange.surname);
  formData.append("avatar", toChange.avatar);
  formData.append("changed_avatar", toChange.changed_avatar);
  formData.append("password", toChange.password);

  api
    .updateUser(formData)
    .then(res => {
      commit("SET_USER", res.data);
      dispatch("hideSpinner", null, {
        root: true
      });
    })
    .catch(error => {
      dispatch("hideSpinner", null, {
        root: true
      });
      const err = error.response.data;
      dispatch(
        "showNotification",
        {
          message: err.message,
          type: "error"
        },
        {
          root: true
        }
      );
    });
};

export const logoutUser = ({ dispatch }) => {
  api
    .logoutUser()
    .then(() => {
      dispatch("clearData", null, {
        root: true
      });
    })
    .catch(err => {
      console.log(err.response);
    });
};

export const clearUser = ({ commit }) => {
  commit("LOGOUT_USER");
};
